import { render, staticRenderFns } from "./LmRepeatFieldsBuilderUi.vue?vue&type=template&id=2277df2c&scoped=true"
import script from "./LmRepeatFieldsBuilderUi.vue?vue&type=script&lang=js"
export * from "./LmRepeatFieldsBuilderUi.vue?vue&type=script&lang=js"
import style0 from "./LmRepeatFieldsBuilderUi.vue?vue&type=style&index=0&id=2277df2c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2277df2c",
  null
  
)

export default component.exports